import React from 'react';
import { motion } from 'framer-motion';
// material
import { Box, BoxProps } from '@material-ui/core';
//
import { varSmallClick, varMediumClick } from './variants';

// ----------------------------------------------------------------------

interface ButtonAnimateProps extends BoxProps {
  mediumClick?: boolean;
}

export const ButtonAnimate:React.FC<ButtonAnimateProps> = ({
  mediumClick = false,
  children,
  sx,
  ...other
}) => (
  <Box
    component={motion.div}
    whileTap="tap"
    whileHover="hover"
    variants={mediumClick ? varMediumClick : varSmallClick}
    sx={{ display: 'inline-flex', ...sx }}
    {...other}
  >
    {children}
  </Box>
);
